import { Component, OnInit, EventEmitter,Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AsignacionCaja } from '../../../models/asignacion-caja';
import * as moment from 'moment';
import { SessionService } from '../../../services/session.service';
import { AsignacionCajaService } from '../../../services/asignacion-caja.service';
import { ArqueoCaja } from '../../../models/arqueo_caja';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';

@Component({
  selector: 'app-cierre-caja-modal',
  templateUrl: './cierre-caja-modal.component.html',
  styleUrls: ['./cierre-caja-modal.component.css'],
  providers: [
	SessionService,
	AsignacionCajaService
  ]
})
export class CierreCajaModalComponent implements OnInit {
	@Input() asignacion_id: string;
	@Output() Respuesta: boolean;
	@Output() action = new EventEmitter();
  	public valor_efectivo: String;
  	public valor_cheque: String;
	public valor_voucher: String;
	public asignacion: AsignacionCaja;
	public fecha_emision;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public loading: boolean = false;
	public inputSelected: String;
  
  	constructor(
		public bsModalRef: BsModalRef,
		public ss: SessionService,
		public asignacionService: AsignacionCajaService,

	) { 
		this.valor_efectivo = "";
		this.valor_cheque = "";
		this.valor_voucher = "";
		this.asignacion = new AsignacionCaja();
		this.fecha_emision = moment(this.fecha_emision);
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
		this.inputSelected = "";
	}

	ngOnInit() {
		//
	}

	isValidForm(){
		/*if( this.valor_efectivo.toString().trim().length < 1 || parseFloat(this.valor_efectivo.toString()) == 0 ){
		//if( this.valor_efectivo == 0 ){
			return false;
		}*/
		return true;
	}

	onSubmit(){
		this.setCierre();

		this.loading = true;
		this.asignacionService.saveCierre(this.asignacion).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.bsModalRef.hide();
				this.Respuesta = true;
				this.action.emit(true);
			},
			err => {
				this.loading = false;
				this.msgSweet.showMessage('error-message', "Ha ocurrido un error");
			}
		);
	}

	setCierre(){
		this.asignacion.id = this.asignacion_id;
		this.asignacion.tipo = 'C';

		if( parseFloat(this.valor_efectivo.toString()) > 0 ){
			let arqueo = new ArqueoCaja();
			arqueo.definicion_id = "2";
			arqueo.empresa_id = this.ss.getData("empresa_id");
			arqueo.fecha = moment(this.fecha_emision).format("YYYY-MM-DD H:mm:ss");
			arqueo.sucursal_id = this.ss.getData("sucursal_id");
			arqueo.tipo = "C";
			arqueo.usuario_id = this.ss.getData("usuario_id");
			arqueo.valor = parseFloat(this.valor_efectivo.toString());
			this.asignacion.arqueos.push(arqueo);
		}
		if( parseFloat(this.valor_cheque.toString()) > 0 ){
			let arqueo2 = new ArqueoCaja();
			arqueo2.definicion_id = "3";
			arqueo2.empresa_id = this.ss.getData("empresa_id");
			arqueo2.fecha = moment(this.fecha_emision).format("YYYY-MM-DD");
			arqueo2.sucursal_id = this.ss.getData("sucursal_id");
			arqueo2.tipo = "C";
			arqueo2.usuario_id = this.ss.getData("usuario_id");
			arqueo2.valor = parseFloat(this.valor_cheque.toString());
			this.asignacion.arqueos.push(arqueo2);
		}
		if( parseFloat(this.valor_voucher.toString()) > 0 ){
			let arqueo3 = new ArqueoCaja();
			arqueo3.definicion_id = "4";
			arqueo3.empresa_id = this.ss.getData("empresa_id");
			arqueo3.fecha = moment(this.fecha_emision).format("YYYY-MM-DD");
			arqueo3.sucursal_id = this.ss.getData("sucursal_id");
			arqueo3.tipo = "C";
			arqueo3.usuario_id = this.ss.getData("usuario_id");
			arqueo3.valor = parseFloat(this.valor_voucher.toString());
			this.asignacion.arqueos.push(arqueo3);
		}
	}

	seleccionar(input){
		this.inputSelected = input;
	}

	clickKeyboard(key){
		switch(this.inputSelected){
			case "E":
				if( key == "C" ){
					this.valor_efectivo = this.valor_efectivo.toString().slice(0,-1)
				}else{
					this.valor_efectivo = this.valor_efectivo + key;
				}
				break;
			case "CH":
				if( key == "C" ){
					this.valor_cheque = this.valor_cheque.toString().slice(0,-1)
				}else{
					this.valor_cheque = this.valor_cheque + key;
				}
				break;
			case "V":
				if( key == "C" ){
					this.valor_voucher = this.valor_voucher.toString().slice(0,-1)
				}else{
					this.valor_voucher = this.valor_voucher + key;
				}
				break;
		}
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/cierre-caja-modal/cierre-caja-modal.component.ts